module.exports = __webpack_public_path__ + "static/media/home_tea.9f5fa007.png";